import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Message, SpinnerService } from 'shared-components';
import { GestionService } from "../../../services/gestion.service";

@Component({
    selector: 'app-pais-denominacion',
    templateUrl: './pais-denominacion.component.html'
})
export class PaisDenominacionComponent implements OnInit {

    private readonly _DEFAULT_ITEMS_PER_PAGE = 5;
    public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
    public currentPage = 0;
    public totalItems: number;
    public readonly visiblePages = 3;

    public new = false;
    public listaPaises = [];

    public _filters;

    public newEditModal;
    public deleteModal;

    public paisId;
    public denominacionId;

    public showError;
    public mensajes = new Array<Message>();

    public _denominacion;

    public editables;

    public allGrupoEtiquetasCaja;
    public allGrupoEtiquetasPallet;

    public toCloseSpinner = 0;

    @Input() denominacion;

    @Output() pushMessage = new EventEmitter<string>();
    @Output() refresh_ = new EventEmitter<boolean>();

    constructor(
        private readonly _spinnerService: SpinnerService,
        private readonly _gestionService: GestionService,
        private readonly _translate: TranslateService
    ) { }

    ngOnInit() {
        const promises: Promise<any>[] = [];
        promises.push(this.getAllGruposEtiquetaCajas());
        promises.push(this.getAllGruposEtiquetaPallet());
        Promise.all(promises).then(
            () => {
                this._denominacion = this.denominacion;
                this.getPaisesByDenominacion();
                return true;
            }, (error) => {
                this.pushMessage.emit('global.error.noResponse');
                console.log('Promise rejected with ' + JSON.stringify(error));
            }
        ).catch(e => console.log(e));
    }

    public pageChange(page) {
        this.currentPage = page - 1;
        this.getPaisesByDenominacion();
    }

    public itemsPerPageChange(items) {
      this._filters.numPagina = this.currentPage = 0;
      this._filters.tamPagina = this.itemsPerPage = items;
      this.getPaisesByDenominacion();
    }

    public getPaisesByDenominacion() {
        this._filters = {
            denominacionId: this.denominacion.id,
            numPagina: this.currentPage,
            tamPagina: this.itemsPerPage
        };
        this._spinnerService.showSpinner();
        this.toCloseSpinner += 1;
        this._gestionService.getPaisesByDenominacionId(this._filters).toPromise().finally(() => {
            this.checkCloseSpinner();
        }).then((resp) => {
            this.totalItems = resp.paginacionMeta.totalCount;
            this.listaPaises = resp.lista;
        });
    }

    public create() {
        this.paisId = null;
        this.denominacionId = null;
        this.newEditModal = true;
    }

    public update(paisDenominacion) {
        this.paisId = paisDenominacion.paisId;
        this.denominacionId = paisDenominacion.denominacionId;
        this.newEditModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._gestionService.deletePaisDenominacion(this.paisId, this.denominacionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then(() => {
            this.close();
            this.pushMessage.emit('global.success.itemDeleted');
            this.getPaisesByDenominacion();
        });
    }

    public askDelete(paisDenominacion) {
        this.paisId = paisDenominacion.paisId;
        this.denominacionId = paisDenominacion.denominacionId;
        this.deleteModal = true;
    }

    public close() {
        this.deleteModal = false;
        this.newEditModal = false;
    }

    public refresh(value) {
        this.editables = '';
        this.newEditModal = false;
        if (value) {
            this.new = false;
            this.getPaisesByDenominacion();
            this.refresh_.emit(true);
        }
    }

    public editableChanged(paisDenominacion) {
        this.editables = paisDenominacion;
        this.new = false;
    }

    public getGruposEtiqueta(paisDenominacion, number) {
        return paisDenominacion.gruposEtiquetaPaisDenominacion.filter(x => x.tipoConfeccionId === number);
    }

    public getAllGruposEtiquetaCajas(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 1
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._gestionService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasCaja = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasCaja.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    public getAllGruposEtiquetaPallet(): Promise<any> {
        return new Promise((resolve, reject) => {
            let _filters = {
                tipoConfeccionId: 2
            };
            this._spinnerService.showSpinner();
            this.toCloseSpinner += 1;
            this._gestionService.getGruposEtiqueta(_filters).toPromise().finally(() => {
                this.checkCloseSpinner();
            }).then((resp) => {
                if (resp.lista.length > 0) {
                    this.allGrupoEtiquetasPallet = resp.lista;
                    var x = this._translate.instant('mantenimientoDenominaciones.paisDenominacion.sinGrupoEtiquetas');
                    this.allGrupoEtiquetasPallet.unshift({ id: 0, des: x });

                }
                setTimeout(resolve, 1);
            });
        });
    }

    private checkCloseSpinner() {
        this.toCloseSpinner -= 1;
        if (this.toCloseSpinner === 0) {
            this._spinnerService.hideSpinner();
        }
    }
}

